import { Injectable } from '@angular/core';
import { Event } from '../models/events-response';
import { filterArray, Options } from '../models/filter';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  constructor() {}

  private defaultFilters: any;
  private appliedFilters: any = [];
  private searchTerm: string = '';

  buildDefaultFilters(allEvents: Event[]): any {
    if (this.defaultFilters != undefined && this.defaultFilters.length > 0) {
      return this.defaultFilters;
    }

    this.defaultFilters = filterArray;
    let organisers: any[] = [];
    let highestPrice: number;
    allEvents.forEach((eventSummary) => {
      if (!organisers.map((organiser) => organiser.desc).includes(eventSummary.organisationName)) {
        organisers.push({
          code: eventSummary.organisationName,
          desc: eventSummary.organisationName,
        });
      }
    });

    //Sort organisation filters by alphabetical order
    organisers.sort((a, b) => (a.desc > b.desc ? 1 : a.desc < b.desc ? -1 : 0));
    
    highestPrice = Math.max(...allEvents.map((event) => event.highestPrice));

    //Apply default filters
    this.defaultFilters[Options.Date].options['min'] = new Date().toISOString().substring(0, 10);
    this.defaultFilters[Options.Organisers].options = organisers;
    this.defaultFilters[Options.Price].options['max'] = highestPrice;

    return this.defaultFilters;
  }

  setAppliedFilters(appliedFilters: any) {
    this.appliedFilters = appliedFilters;
  }

  getAppliedFilters() {
    let appliedFilters = this.appliedFilters;
    this.appliedFilters = [];
    if (appliedFilters == undefined || appliedFilters.length == 0) {
      appliedFilters = this.defaultFilters;
    }
    return appliedFilters;
  }

  setSearchTerm(searchTerm: string) {
    this.searchTerm = searchTerm;
  }

  getSearchTerm() {
    const searchTerm = this.searchTerm;
    this.searchTerm = '';
    return searchTerm;
  }
}
